import { FormProvider } from 'react-hook-form'
import styled from '@emotion/styled'

import SectionBlock from '@src/components/signup/SectionBlock'
import AccountInfoSection from '@src/components/signup/AccountInfoSection'
import BrandInfoSection from '@src/components/signup/BrandInfoSection'
import BusinessInfoSection from '@src/components/signup/BusinessInfoSection'
import ContactInfoSection from '@src/components/signup/ContactInfoSection'
import BottomButton from '@src/components/signup/BottomButton'

import useSignup from '@src/hooks/auth/signup/useSignup'

const SignupForm = () => {
	const { methods, handleSubmit } = useSignup()

	return (
		<FormProvider {...methods}>
			<form onSubmit={handleSubmit}>
				<SectionBlock title="계정 정보" subTitle="판매자센터 로그인 시 사용됩니다.">
					<AccountInfoSection />
				</SectionBlock>
				<SectionBlock title="브랜드 정보">
					<BrandInfoSection />
				</SectionBlock>
				<SectionBlock title="사업자 정보" subTitle="아래 정보로 세금계산서가 발행됩니다.">
					<BusinessInfoSection />
				</SectionBlock>
				<SectionBlock title="담당자 정보">
					<ContactInfoSection />
				</SectionBlock>
				<AgreeSection>
					<AgreeInstruction>
						입점하기 클릭시,{' '}
						<TermsLink
							onClick={() =>
								window.open(
									'https://picturesque-avatar-ac9.notion.site/689fb573de9646cba3deebb33dc8dfb7?pvs=4',
									'_blank',
								)
							}
						>
							이용약관
						</TermsLink>{' '}
						및{' '}
						<TermsLink
							onClick={() => {
								window.open(
									'https://picturesque-avatar-ac9.notion.site/0d67317452ca442295f71cd8b7e1b9f6?pvs=4',
									'_blank',
								)
							}}
						>
							개인정보처리방침
						</TermsLink>
						에 동의한 것으로 간주됩니다.
					</AgreeInstruction>
				</AgreeSection>
				<BottomButton />
			</form>
		</FormProvider>
	)
}

const AgreeSection = styled.div`
	padding: 0.6rem 12.5rem;
	display: flex;
	justify-content: center;
`

const AgreeInstruction = styled.div`
	width: 103rem;
	font-size: 1.2rem;
	color: gray;
`

const TermsLink = styled.span`
	text-decoration: underline;
	cursor: pointer;
`

export default SignupForm
